export const ITEM_BATCH_ACTION_LABELS = {
    change_group: '그룹 변경',
    delete: '상품 삭제',
    change_price: '가격 수정',
    change_discount: '할인 수정',
    reset_price: '가격 복구',
    activate: '작업 활성화',
    deactivate: '작업 비활성화',
    request_urgent_enqueue: '우선 실행',
    cancel_urgent_enqueue: '우선 실행 해제',
    try_assign_my_compare_item: '내상품 자동지정 시도',
    change_rank_price_basis: '순위 기준 변경',
    change_gap_price_basis: '차액 기준 변경',
    change_adjust_strategy: '조정 방식 변경',
    instant_process: '즉시 실행',
    instant_process_dry_run: '즉시 실행(예행)',
} as const;

export type ItemBatchActionType = keyof typeof ITEM_BATCH_ACTION_LABELS;

export type ItemBatchFormState = {
    selectedGroup: string;
    newPrice: string;
    newDiscount: string;
    priceBasis: string;
    adjustStrategy: string;
};

export function isItemBatchActionType(value: string): value is ItemBatchActionType {
    return value in ITEM_BATCH_ACTION_LABELS;
}

export function buildBatchPayload(
    actionType: ItemBatchActionType | '',
    form: ItemBatchFormState,
): Record<string, unknown> | null {
    switch (actionType) {
        case 'change_group':
            if (!form.selectedGroup) return null;
            return {
                action: 'change_group',
                itemgroup: form.selectedGroup === 'none' ? null : form.selectedGroup,
            };
        case 'change_price': {
            const price = parseFloat(form.newPrice);
            if (!form.newPrice || isNaN(price)) return null;
            return { action: 'change_price', price };
        }
        case 'change_discount': {
            const discount = Number(form.newDiscount);
            if (!form.newDiscount.trim() || !Number.isSafeInteger(discount) || discount < 0) return null;
            return { action: 'change_discount', discount };
        }
        case 'change_rank_price_basis':
        case 'change_gap_price_basis':
            return form.priceBasis === 'price_exposed' || form.priceBasis === 'price'
                ? { action: actionType, price_basis: form.priceBasis }
                : null;
        case 'change_adjust_strategy':
            return [
                'adjust_price',
                'adjust_discount',
                'adjust_price_match_discount',
                'adjust_discount_match_price',
            ].includes(form.adjustStrategy)
                ? { action: actionType, adjust_strategy: form.adjustStrategy }
                : null;
        case 'reset_price':
        case 'activate':
        case 'deactivate':
        case 'request_urgent_enqueue':
        case 'cancel_urgent_enqueue':
        case 'try_assign_my_compare_item':
        case 'instant_process':
        case 'instant_process_dry_run':
        case 'delete':
            return { action: actionType };
        default:
            return null;
    }
}
